import type { useContactCtaModel } from '@/components/shared/contact-cta/contact-cta.model'

type ContactCtaViewProps = ReturnType<typeof useContactCtaModel>

export function ContactCtaView({ label, href }: ContactCtaViewProps) {
  return (
    <a href={href} className="fz-contact-cta">
      <svg
        className="fz-contact-cta__icon"
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          fill="currentColor"
          d="M2 5.5A2.5 2.5 0 0 1 4.5 3h15A2.5 2.5 0 0 1 22 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 18.5zm2.2.5 7.15 5.804a1 1 0 0 0 1.3 0L19.8 6zM4 8.06V18.5c0 .276.224.5.5.5h15a.5.5 0 0 0 .5-.5V8.06l-6.723 5.457a3 3 0 0 1-3.554 0z"
        />
      </svg>
      <span className="fz-contact-cta__label">{label}</span>
    </a>
  )
}
